
// Called by custom/init-foundation.js
// Some accordions must work in a certain breakpoint only
// We disable functionality according to window size
// .accordion-break-sm-only - breaks on screens lower that 640px
// .accordion-break-md - breaks starting  640px
// .accordion-break-lg - breaks starting  1024px
function initBreakAccordion(){
  var smClss =  ".accordion-break-sm-only";
  var mdClss =  ".accordion-break-md";
  var lgClss =  ".accordion-break-lg";
  var breakpoints = {
    md: 640,
    lg: 1024
  }

  var smAccordions = document.querySelectorAll(smClss);
  if(smAccordions.length > 0){
    // accordions found
    smAccordions.forEach( function(itm, i) {
      breakAccordion(itm, 0);
    });
  }
  
  var mdAccordions = document.querySelectorAll(mdClss);
  if(mdAccordions.length > 0){
    // accordions found
    mdAccordions.forEach( function(itm, i) {
      breakAccordion(itm, breakpoints.md);
    });
  }

  var lgAccordions = document.querySelectorAll(lgClss);
  if(lgAccordions.length > 0){
    // accordions found
    lgAccordions.forEach( function(itm, i) {
      breakAccordion(itm, breakpoints.lg);
    });
  }

  function breakAccordion(item, breakStartingPX){
    var content = item.querySelectorAll(".accordion-content");

    if(content.length > 0){
      switch(breakStartingPX) {
        case 0:
          // small-only
          content.forEach( function(c, i) {
            smallCheck(c);
          });
          break;
        default:
          // starting the px breakpoint
          content.forEach( function(c, i) {
            defaultCheck(c, breakStartingPX);
          });
      }// switch
    }// if there's content

    function smallCheck(elm){
      if(getSize().w < breakpoints.md){
        openAccItem(elm);
      }
      else{
        closeAccItem(elm);
      }
    }
    function defaultCheck(elm, bp){
      if(getSize().w >= bp){
        openAccItem(elm);
      }
      else{
        closeAccItem(elm);
      }
    }
  
    function openAccItem(itm){
      itm.parentElement.classList.remove("disableItem");
      itm.parentElement.classList.add("activateItem");
      // always open
      item.setAttribute("aria-hidden", "false");
    }
    function closeAccItem(itm){
      itm.parentElement.classList.add("disableItem");
      itm.parentElement.classList.remove("activateItem");
      
      if(!itm.parentElement.classList.contains("is-active")){
        // close only if it wasn't active already
        item.setAttribute("aria-hidden", "true");
      }
    }
  }
}